import {
    ACTION_TO_SET_FAVORITE_TOPIC,
    ACTION_TO_SUBSCRIBE_TOPIC,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_TOPIC,
    EXPLAIN_TOPIC_DELETION,
    FORUM_FEED_SUBSCRIBED,
    FORUM_TOPIC_SUBSCRIBED_TOAST_name_link,
    FORUM_TOPIC_topic_IS_ADDED_TO_FAVORITES,
    FORUM_TOPIC_topic_IS_REMOVED_FROM_FAVORITES,
} from 'mk/autogenerated/translations/Topic.sagas.11261ba1db872b735088d645b8490656'
import assetUrl from 'mk/common/assetUrl';
import { photoUrl } from 'mk/photo/photoUrl';
import {
    forum_api_delete_topic_url,
    forum_api_get_topic_url,
    forum_api_remove_topic_cover_photo_url,
    forum_api_topic_set_as_favorite_url,
    forum_api_topic_subscribe_url,
    forum_api_topic_unsubscribe_url,
    forum_api_update_topic_cover_photo_url,
} from 'mk/urls/functions';
import { toastAdd } from 'mk2/actions';
import { getOrdersChartState } from 'mk2/apps/bo/containers/OrdersChart/OrdersChart.selectors';
import { forumUpdateComplaintsStatistics } from 'mk2/apps/forum/actions';
import { TOPIC_COVER_UPLOAD_FORM_NAME } from 'mk2/apps/forum/components/TopicCoverForm';
import {
    FORUM_DELETE_TOPIC,
    ForumDeleteTopicAction,
    forumDeleteTopicApi,
    TOPIC_COVER_REMOVE_TRIGGER,
    TOPIC_COVER_SUBMIT_TRIGGER,
    TOPIC_COVER_UPLOAD_TRIGGER,
    TOPIC_FETCH_TRIGGER,
    TOPIC_SET_AS_FAVORITE_TRIGGER,
    TOPIC_SUBSCRIBE_TRIGGER,
    TOPIC_UNSUBSCRIBE_TRIGGER,
    topicCoverRemoveApi,
    TopicCoverRemoveNormalizedResponse,
    TopicCoverRemoveTriggerAction,
    topicCoverSubmitApi,
    TopicCoverSubmitNormalizedResponse,
    TopicCoverSubmitTriggerAction,
    topicCoverUploadApi,
    TopicCoverUploadNormalizedResponse,
    TopicCoverUploadTriggerAction,
    TopicDeleteNormalizedResponse,
    topicFetchApi,
    TopicFetchNormalizedResponse,
    TopicFetchTriggerAction,
    topicSetAsFavoriteApi,
    TopicSetAsFavoriteTriggerAction,
    topicSubscribeApi,
    TopicSubscribeTriggerAction,
    topicUnsubscribeApi,
    TopicUnsubscribeTriggerAction,
} from 'mk2/apps/forum/containers/Topic/Topic.actions';
import { TopicState } from 'mk2/apps/forum/containers/Topic/Topic.reducers';
import { getTopicState } from 'mk2/apps/forum/containers/Topic/Topic.selectors';
import { topicUrl } from 'mk2/apps/forum/helpers';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ComplaintsStatisticsPerPost,
    CounsellingEntity,
    CounsellingSchema,
    PostEntity,
    PostSchema,
    TopicEntity,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { forumSubscribedUrl, forumUrl } from 'mk2/apps/forum/urls';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import Toast from 'mk2/components/toasts/Toast';
import { FormPageType } from 'mk2/constants';
import { pageHeaderAddFeedMenuItem, pageHeaderRemoveFeedMenuItem } from 'mk2/containers/PageHeader/PageHeader.action';
import { photosUploadTrigger } from 'mk2/containers/PhotosUpload/PhotosUpload.actions';
import {
    handleXHRGetErrorSaga,
    handleXHRPostErrorSaga,
    normalizeError,
    XHRAction,
    XHRGetError,
    XHRPostError,
} from 'mk2/helpers/api';
import { handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { mkReduxFormOpenPage } from 'mk2/helpers/form.actions';
import { getPhotoPreview } from 'mk2/helpers/photos';
import { showSuccessToast } from 'mk2/helpers/toasts';
import { getLogger } from 'mk2/logger';
import { AppState } from 'mk2/reducers';
import { checkIfUserIsLoggedIn } from 'mk2/sagas/auth';
import { PhotoPreviewSchema, UserEntity } from 'mk2/schemas';
import { findDenormalizedEntityBySlug, getDenormalizedEntity } from 'mk2/selectors';
import { redirectInPWASaga } from 'mk2/services/browserHistory';
import { normalize } from 'normalizr';
import React from 'react';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

const logger = getLogger('forum/Topic.sagas');

interface ApiResponseTopic {
    body: {
        topic: TopicEntity;
        posts: PostEntity[];
        deletedBy: UserEntity;
        hasNext: number;
        hasPrevious: number;
        isSubscribed: boolean;
        brandDaysCampaign: BrandDaysCampaignEntity;
        brandDaysCampaignGreetingText: string;
        counselling: CounsellingEntity;
        counsellingPostsCount: number | null;
        notificationsOn: number[];
        complaintsStatistics: ComplaintsStatisticsPerPost;
        subscribers: number;
    };
}

function* fetchTopic({ slug, hashtags, after, xhr }: TopicFetchTriggerAction & XHRAction) {
    yield put(topicFetchApi.request(slug, hashtags, after));

    try {
        const response: ApiResponseTopic = yield call(
            () => xhr.get(forum_api_get_topic_url(slug), { after, h: hashtags.length ? hashtags.join(',') : undefined }),
        );

        const normalizedResponse: TopicFetchNormalizedResponse = normalize(response.body, {
            posts: [PostSchema],
            topic: TopicSchema,
            counselling: CounsellingSchema,
            brandDaysCampaign: BrandDaysCampaignSchema,

        });

        yield put(forumUpdateComplaintsStatistics(response.body.complaintsStatistics));

        yield put(topicFetchApi.success(
            slug, hashtags, after,
            response.body.hasNext,
            response.body.hasPrevious,
            normalizedResponse,
            response.body.notificationsOn,
        ));

    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(topicFetchApi.failure(slug, hashtags, after, normalizeError(error)));
    }
}

interface ApiSubscribeTopic {
    body: {
         isSubscribed: boolean;
    };
}

function* subscribeTopic({ slug, username, xhr }: TopicSubscribeTriggerAction & XHRAction) {
    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_SUBSCRIBE_TOPIC))) {
        return;
    }

    yield put(topicSubscribeApi.request(slug));

    try {
        const response: ApiSubscribeTopic =  yield call(
            () => xhr.post(forum_api_topic_subscribe_url(username), { slug }),
        );

        const topic: TopicEntity = yield select(
            (state: AppState) => findDenormalizedEntityBySlug<TopicEntity>(state, TopicSchema, slug),
        );

        yield put(toastAdd('success', {
            component: ({ remove }) => (
                <Toast type="success" remove={remove}>
                    <Interpolate
                        i18nKey={FORUM_TOPIC_SUBSCRIBED_TOAST_name_link}
                        name={<strong>{topic.name}</strong>}
                        link={<Link to={forumSubscribedUrl}>{FORUM_FEED_SUBSCRIBED}</Link>}
                    />
                </Toast>
            ),
        }));

        yield put(topicSubscribeApi.success(slug, response.body.isSubscribed));

        const icon = topic.coverPhoto
            ? photoUrl(topic.coverPhoto, 's96x96')
            : assetUrl + 'img/photoblog/groups/icon-feed-menu-group.gif';

        yield put(pageHeaderAddFeedMenuItem(
            'my-forums',
            `topic-${topic.id}`,
            topic.name,
            icon,
            topicUrl(topic),
        ));

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(topicSubscribeApi.failure(slug, normalizeError(error)));
    }
}

interface ApiUnsubscribeTopic {
    body: {
        isSubscribed: boolean;
    };
}

function* unsubscribeTopic({ slug, username, xhr }: TopicUnsubscribeTriggerAction & XHRAction) {
    yield put(topicUnsubscribeApi.request(slug));

    try {
        const response: ApiUnsubscribeTopic =  yield call(
            () => xhr.post(forum_api_topic_unsubscribe_url(username), { slug }),
        );

        const topic: TopicEntity = yield select(
            (state: AppState) => findDenormalizedEntityBySlug<TopicEntity>(state, TopicSchema, slug),
        );

        yield put(topicUnsubscribeApi.success(slug, response.body.isSubscribed));

        yield put(pageHeaderRemoveFeedMenuItem('my-forums', `topic-${topic.id}`));
        const topicState: TopicState = yield select((state: AppState) => getTopicState(state, topic.slug));
        if (topicState.isFavorite) {
            yield put(pageHeaderRemoveFeedMenuItem('my-favorites', `topic-${topic.id}`));
        }

        // po unsubscribe mame odist z diskusnej skupiny prec
        yield redirectInPWASaga(forumUrl);
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(topicUnsubscribeApi.failure(slug, normalizeError(error)));
    }
}

interface ApiSetTopicAsFavorite {
    body: {
        isFavorite: boolean;
    };
}

function* setTopicAsFavorite({ topicId, userId, setAsFavorite, xhr }: TopicSetAsFavoriteTriggerAction & XHRAction) {
    const topic: TopicEntity = yield select(
        (state: AppState) => getDenormalizedEntity<TopicEntity>(state, TopicSchema, topicId),
    );

    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_SET_FAVORITE_TOPIC))) {
        return;
    }

    yield put(topicSetAsFavoriteApi.request(topic.slug, userId, setAsFavorite));

    try {
        const response: ApiSetTopicAsFavorite =  yield call(
            () => xhr.post(forum_api_topic_set_as_favorite_url(), {
                topicId,
                userId,
                setAsFavorite,
            }),
        );

        yield put(topicSetAsFavoriteApi.success(topic.slug, userId, setAsFavorite));

        if (setAsFavorite) {
            const icon = topic.coverPhoto
                ? photoUrl(topic.coverPhoto, 's96x96')
                : assetUrl + 'img/photoblog/groups/icon-feed-menu-group.gif';

            yield put(pageHeaderAddFeedMenuItem(
                'my-favorites',
                `topic-${topic.id}`,
                topic.name,
                icon,
                topicUrl(topic),
            ));
        } else {
            yield put(pageHeaderRemoveFeedMenuItem(
                'my-favorites',
                `topic-${topic.id}`,
            ));
        }

        yield showSuccessToast(
            <Interpolate
                i18nKey={response.body.isFavorite ? FORUM_TOPIC_topic_IS_ADDED_TO_FAVORITES : FORUM_TOPIC_topic_IS_REMOVED_FROM_FAVORITES}
                group={<strong>{topic.name}</strong>}
            />,
        );

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(topicSetAsFavoriteApi.failure(topic.slug, userId, setAsFavorite, normalizeError(error)));
    }
}

interface ApiResponseDeleteTopic {
    body: {
        topic: TopicEntity;
        isSubscribed: boolean;
    };
}

function* deleteTopic({ slug, xhr }: ForumDeleteTopicAction & XHRAction) {
    let reason;
    if (!window.confirm(ARE_YOU_SURE_YOU_WANT_TO_DELETE_TOPIC)) {
        return;
    } else {
        reason = window.prompt(EXPLAIN_TOPIC_DELETION);
        if (reason === null) {
            return;
        }
    }

    yield put(forumDeleteTopicApi.request(slug));

    try {
        const response: ApiResponseDeleteTopic = yield call(
            () => xhr.post(forum_api_delete_topic_url(slug), { comment: reason }),
        );

        const normalizedResponse: TopicDeleteNormalizedResponse = normalize({
            topic: response.body.topic,
        }, {
            topic: TopicSchema,
        });

        yield put(forumDeleteTopicApi.success(slug, normalizedResponse));

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(forumDeleteTopicApi.failure(slug, normalizeError(error)));
    }
}

function* uploadCoverPhoto({ slug, config, files, xhr }: TopicCoverUploadTriggerAction & XHRAction) {
    try {
        yield put(mkReduxFormOpenPage(TOPIC_COVER_UPLOAD_FORM_NAME, FormPageType.ChangeTopicCover));
        yield put(topicCoverUploadApi.request(slug, config, files));
        yield put(photosUploadTrigger(TOPIC_COVER_UPLOAD_FORM_NAME, config, files, FormPageType.ChangeTopicCover));
        const photoPreview = [];
        for (let i = 0; i < files.length; i++) {
            const onePhotoPreview = yield call(getPhotoPreview, files[i]);
            photoPreview.push(onePhotoPreview);
        }
        const normalizedResponse: TopicCoverUploadNormalizedResponse = normalize(
            {photoPreview},
            {photoPreview: [PhotoPreviewSchema]},
        );
        yield put(topicCoverUploadApi.success(slug, config, files, normalizedResponse));
    } catch (error) {
        yield put(topicCoverUploadApi.failure(slug, config, files, error));
    }
}

interface ApiResponseRemoveCoverPhoto {
    body: {
        topic: TopicEntity;
    };
}

function* removeCoverPhoto({ topicId, xhr }: TopicCoverRemoveTriggerAction & XHRAction) {
    yield put(topicCoverRemoveApi.request(topicId));
    try {
        const response: ApiResponseRemoveCoverPhoto = yield call(() => xhr.post(forum_api_remove_topic_cover_photo_url(), { topicId }));
        const normalizedResponse: TopicCoverRemoveNormalizedResponse = normalize(response.body, {
            topic: TopicSchema,
        });
        yield put(topicCoverRemoveApi.success(topicId, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(topicCoverRemoveApi.failure(topicId, normalizeError(error)));
    }
}

interface ApiResponseSaveCoverPhoto {
    body: {
        topic: TopicEntity;
    };
}

function* saveCoverPhoto({values, topicId, xhr}: TopicCoverSubmitTriggerAction & XHRAction) {
    yield put(topicCoverSubmitApi.request(values, topicId));

    if (values.photos.length !== 1 || !values.photos[0]) {
        throw new Error('Missing photo');
    }

    try {
        const response: ApiResponseSaveCoverPhoto = yield call(
            () => xhr.put(forum_api_update_topic_cover_photo_url(), {
                topicId,
                photoId: values.photos[0].photoId,
            }),
        );
        const normalizedResponse: TopicCoverSubmitNormalizedResponse = normalize(response.body, {topic: TopicSchema});
        yield handleXHRFormSuccessSaga(TOPIC_COVER_UPLOAD_FORM_NAME);
        yield put(topicCoverSubmitApi.success(values, topicId, normalizedResponse));
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(topicCoverSubmitApi.failure(values, topicId, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(TOPIC_FETCH_TRIGGER, fetchTopic),
        takeLatest(TOPIC_COVER_UPLOAD_TRIGGER, uploadCoverPhoto),
        takeLatest(TOPIC_COVER_REMOVE_TRIGGER, removeCoverPhoto),
        takeLatest(TOPIC_COVER_SUBMIT_TRIGGER, saveCoverPhoto),
        takeEvery(TOPIC_SUBSCRIBE_TRIGGER, subscribeTopic),
        takeEvery(TOPIC_UNSUBSCRIBE_TRIGGER, unsubscribeTopic),
        takeEvery(TOPIC_SET_AS_FAVORITE_TRIGGER, setTopicAsFavorite),
        takeEvery(FORUM_DELETE_TOPIC, deleteTopic),
    ]);
}
